import React from 'react'
import { BackTop } from 'antd'


import './outside-common.css'

class OutsideFooter extends React.Component {
    render() {
        return (
            <div className="contain-fluid">
                <div className="outsideFooter">
                    <div className="logo">
                        <a href="http://www.google.com">TUT</a>
                    </div>
                    <div className="copyright">Copyright &copy; 2020 台南應用科技大學</div>
                    <BackTop>
                        <div className="goTop"><i className="fas fa-arrow-circle-up"></i></div>
                    </BackTop>
                </div>
            </div>
        )
    }
}


export default OutsideFooter